'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var detectTouchEvents = {
  update: function update() {
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
      detectTouchEvents.hasApi = 'ontouchstart' in window;
      detectTouchEvents.maxTouchPoints = detectTouchEvents.hasApi ? window.navigator && window.navigator.maxTouchPoints : undefined;
    }
  }
};

detectTouchEvents.update();
exports.default = detectTouchEvents;


//////////////////
// WEBPACK FOOTER
// ./~/detect-touch-events/lib/index.js
// module id = 32
// module chunks = 0